export default (hashid) => {
  const url = `${process.env.API_LOCATION}/purchases/${hashid}/pdf/show?token=${localStorage.getItem('id_token')}`;
  window.open(url);
};



// WEBPACK FOOTER //
// ./src/app/services/purchase/showPdf.js